import { jsxs as i, jsx as p } from "react/jsx-runtime";
import { useState as d } from "react";
import { Header as x } from "./components/Header.js";
import { Content as S } from "./components/Content.js";
import { Footer as c } from "./components/Footer.js";
import { TIPS_LENGTH as h } from "./constants/tips.js";
/* empty css                                                   */const w = ({
  socialMediaLinks: a,
  handleCloseAction: r,
  handleFinishAction: n,
  genericTaggingEvent: s
}) => {
  const [t, m] = d(1), e = (o) => {
    s == null || s("ofertas_pelo_whatsapp", {
      clickText: o,
      name: t
    });
  };
  return /* @__PURE__ */ i("div", { className: "onboarding-container", children: [
    /* @__PURE__ */ p(x, { sendEvent: e, handleCloseAction: r }),
    /* @__PURE__ */ p(
      S,
      {
        step: t,
        sendEvent: e,
        socialMediaLinks: a
      }
    ),
    /* @__PURE__ */ p(
      c,
      {
        step: t,
        handleBackStep: (o) => {
          e(o.target.innerText), t > 1 ? m(t - 1) : r();
        },
        handleNextStep: (o) => {
          e(o.target.innerText);
          const f = n || r;
          t < h ? m(t + 1) : f();
        }
      }
    )
  ] });
};
export {
  w as Onboarding
};
